export const hourStringToAP = (s: string) => {
  if (s?.split(':').length != 2) return null
  const hours = Number.parseInt(s.split(':')[0])
  const minutes = s.split(':')[1]
  const adjustedHours = hours % 12
  const prettyHours = adjustedHours === 0 ? 12 : adjustedHours
  const retVal = hours < 12 ? `${prettyHours}:${minutes}a` : `${prettyHours}:${minutes}p`
  return retVal
}
